module.exports = __webpack_public_path__ + "static/hildingvilding_spion-e3a81a1ac5cd5c221a7d7cbabefa0ec8.svg";